import React from "react";
import {Button} from "@/components/ui/button";
import {Input} from "@/components/ui/input";
import {Label} from "@/components/ui/label";
import {Modal} from "@/hook/useModal";
import {Connection} from "@xyflow/react";

export const BRANCH_EDGE_KEY_MODAL_ID = "workflow-branch-edge-key";

const BRANCH_KEY_INPUT_ID = "workflow-branch-edge-key-input";

export type BranchEdgeKeyModalMode = "connect" | "edit";

export type BranchKeyModalContext =
    | { mode: "connect"; connection: Connection }
    | { mode: "edit"; source: string; target: string; previousKey: string };

export interface BranchEdgeKeyModalProps {
    mode: BranchEdgeKeyModalMode;
    branchKey: string;
    onBranchKeyChange: (value: string) => void;
    onConfirm: () => void;
    onCancel: () => void;
    onModalClose: () => void;
}

const modalTitle: Record<BranchEdgeKeyModalMode, string> = {
    connect: "분기 연결 (branchMap 키)",
    edit: "분기 키 수정",
};

const confirmLabel: Record<BranchEdgeKeyModalMode, string> = {
    connect: "연결",
    edit: "저장",
};

const BranchEdgeKeyModal: React.FC<BranchEdgeKeyModalProps> = ({
    mode,
    branchKey,
    onBranchKeyChange,
    onConfirm,
    onCancel,
    onModalClose,
}) => {
    return (
        <Modal
            id={BRANCH_EDGE_KEY_MODAL_ID}
            size="sm"
            title={modalTitle[mode]}
            onClose={onModalClose}
        >
            <div className="mt-4 flex flex-col gap-6">
                <div className="flex flex-col gap-3">
                    <Label htmlFor={BRANCH_KEY_INPUT_ID}>분기 이름</Label>
                    <Input
                        id={BRANCH_KEY_INPUT_ID}
                        value={branchKey}
                        onChange={(e) => onBranchKeyChange(e.target.value)}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                                onConfirm();
                            }
                        }}
                        autoComplete="off"
                        placeholder="ex) matched, unmatched"
                        autoFocus
                        aria-label="branch-key"
                    />
                </div>
                <div className="flex justify-end gap-2">
                    <Button type="button" variant="outline" onClick={onCancel}>
                        취소
                    </Button>
                    <Button type="button" onClick={onConfirm}>
                        {confirmLabel[mode]}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default BranchEdgeKeyModal;
